import PropTypes from 'prop-types';
import { Toaster } from 'sonner';

export { useSnackbar, enqueueSnackbar, closeSnackbar } from './snackbar';

export default function SnackbarProvider({ children }) {
    return (
        <>
            {children}
            <Toaster position="top-center" gap={12} toastOptions={{ unstyled: true }} />
        </>
    );
}

SnackbarProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
